import { defineMessages } from "react-intl";

export const messages = defineMessages({
  emptyText: {
    id: "sampleRequestEmpty",
    defaultMessage: "No sample requests found",
  },
});

export const columnsMessages = defineMessages({
  date: {
    id: "sampleRequestDate",
    defaultMessage: "Date",
  },
  customer: {
    id: "sampleRequestCustomer",
    defaultMessage: "Customer",
  },
  address: {
    id: "sampleRequestAddress",
    defaultMessage: "Address",
  },
  city: {
    id: "sampleRequestCity",
    defaultMessage: "City",
  },
  postalCode: {
    id: "sampleRequestPostalCode",
    defaultMessage: "Postal Code",
  },
  country: {
    id: "sampleRequestCountry",
    defaultMessage: "Country",
  },
  action: {
    id: "sampleRequestAction",
    defaultMessage: "Action",
  },
});